import { render, staticRenderFns } from "./LatestJob.vue?vue&type=template&id=19a5bbc2&"
import script from "./LatestJob.vue?vue&type=script&lang=js&"
export * from "./LatestJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports